import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';
import { LoginService } from './auth/login/login.service';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html? v1',
  styleUrls: ['./app.component.scss']
})
// export class AppComponent implements OnDestroy
export class AppComponent implements AfterViewInit {
  title = 'INSIDER';
  key: string;
    @ViewChild(ToastContainerDirective, { static: true })
  toastContainer!: ToastContainerDirective;

  constructor(private bnIdle: BnNgIdleService, public router: Router, 
    private toastr: ToastrService,
    private http:HttpClient,public loginService: LoginService){}
  ngOnInit(): void {
    this.bnIdle.startWatching(600).subscribe((isTimedOut: boolean) => {
      if (isTimedOut) {
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('sdd_user_permission');
        sessionStorage.removeItem('sdd_user_type');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('sdd_user_type');
        sessionStorage.removeItem('access_success');
        sessionStorage.removeItem('sdd_access_roles');
        this.bnIdle.stopTimer();
        this.loginService.doLogout(event);
        this.router.navigate(['/auth/login'])    
        
      }
    });
    
     //console.log(window.location.hostname)

  }
  @HostListener('window:beforeunload', ['$event'])
beforeUnload(event: BeforeUnloadEvent) {
  const accessUser = sessionStorage.getItem('access_user');
  if (!accessUser) return;

  const key = `ACTIVE_UPSI_IDS_${accessUser}`;
  if (localStorage.getItem(key)) {
    event.preventDefault();
    event.returnValue = '';
  }
}


  ngAfterViewInit() {
    this.toastr.overlayContainer = this.toastContainer;
  }
  // @HostListener('window:unload')
  // async ngOnDestroy()
  // {
  //   await this.loginService.doLogout(event);
  // }

//   @HostListener('window:keydown', ['$event'])
//   handleHotkey(event: KeyboardEvent){
//     this.key = event.key;
//    event.preventDefault();
//  }


//  @HostListener('document:keypress', ['$event'])
// handleKeyboardEvent(event: KeyboardEvent) {
//     this.key = event.key;
//     console.log("00",this.key);
//     event.preventDefault();
// }
}

